import { useRefreshAllDisputeSummaries, useRefreshDisputeDetails, useRefreshDisputeDocuments, useRefreshDisputeTracking } from 'state';

export default function useRefreshDispute(disputeId: string, refreshDetails: boolean = true, refreshTracking: boolean = true, refreshFiles: boolean = true) {
    const refreshDisputeDispute = useRefreshDisputeDetails(disputeId);
    const refreshDisputeSummaries = useRefreshAllDisputeSummaries();
    const refreshDisputeDocuments = useRefreshDisputeDocuments(disputeId);
    const refreshDisputeTracking = useRefreshDisputeTracking(disputeId);
    
    return () => {
        if (refreshDetails) {
            refreshDisputeDispute();
            refreshDisputeSummaries();
        //    refreshDisputeDocuments();
        }
        refreshTracking && refreshDisputeTracking();
        refreshFiles && refreshDisputeDocuments();
    
    };
};